/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
 import * as types from "./types";

 const mutations = {
  [types.SET_SWATCH_TABS](state, payload) {
    state.swatchTabsMetadata = payload;
  },
  [types.SET_ACTIVE_TAB](state, payload) {
    state.activeTab = payload;
  },
};

export default mutations;
